export default __webpack_public_path__ + "static/media/scan-bunifikasi-picturemark-d.5f943cb3.svg";